<template>
	<div class="input-group-c">
		<!-- Prepend Slot -->
		<span v-if="isPrepend" class="input-prepend-c">
			<slot name="prepend"></slot>
		</span>

		<!-- Input -->
		<input :type="type" :placeholder="placeholder"
			:class="['input-field-c', 'text-xs', `${isPrepend ? '' : 'pl-3'}`, `${isAppend ? '' : 'pr-3'}`]"
			v-bind:value="value" @input="onInput" />

		<!-- Append Slot -->
		<span v-if="isAppend" class="input-append-c">
			<slot name="append"></slot>
		</span>
	</div>
</template>

<script>
export default {
	name: 'InputWithPrependAppend',
	props: {
		isPrepend: {
			type: Boolean,
			default: false
		},
		isAppend: {
			type: Boolean,
			default: false
		},
		type: {
			type: String,
			default: 'text'
		},
		placeholder: {
			type: String,
			default: ''
		},

		value: {
			type: String,
			default: ''
		},

		numberOnly: {
			type: Boolean,
			default: false
		}
	},

	methods: {
		onInput(event) {
			if (this.numberOnly && !/[0-9]/.test(event.key)) {
				event.target.value = event.target.value.replace(/\D/g, '')
			}

			this.$emit('input', event.target.value)
		}
	}
}
</script>

<style scoped>
/* Wrapper for Input Group */
.input-group-c {
	display: flex;
	align-items: center;
	/* border: 1px solid #d1d5db; */
	/* Light gray border */
	border-radius: 0.375rem;
	/* Rounded corners */
	overflow: hidden;
	background-color: var(--grey-1-color);
	/* Light background */
	color: white;
	height: 2.5rem;
}

/* Prepend and Append Styling */
.input-prepend-c,
.input-append-c {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	padding: 0 0.75rem;
	/* Horizontal padding */
	font-size: 0.875rem;
	/* Text size */
	/* color: #6b7280; */
	/* Gray text color */
	background-color: var(--grey-1-color);
	/* Slightly darker background */
	/* border-right: 1px solid #d1d5db; */
	/* Right border for prepend */
}

.input-append-c {
	/* border-left: 1px solid #d1d5db; */
	/* Left border for append */
}

/* Input Field Styling */
.input-field-c {
	/* Allows input to grow */
	flex: 1;

	/* Inner padding */
	/* padding: 0; */

	/* Remove default border */
	border: none;

	/* Text size */
	/* font-size: 0.875rem; */

	/* Remove focus outline */
	outline: none;

	/* Transparent background */
	background-color: transparent;

	color: white;
}

/* Focus State */
.input-field-c:focus {
	/* background-color: #fff; */
	/* White background on focus */
}
</style>
